import AlbumDetail from '@/views/album/AlbumDetail'
import AlbumsMassive from '@/views/album/AlbumsMassive'
import Albums from '@/views/Albums'
// import Login from '@/views/Login'
import { createRouter, createWebHistory } from 'vue-router'
import AlbumsIndividual from '../views/album/AlbumsIndividual.vue'

const routes = [
  {
    path: '/',
    redirect: '/albums/individual'
  },
  {
    path: '/albums',
    component: Albums,
    children: [
      {
        path: '',
        redirect: 'individual'
      },
      {
        path: 'individual',
        name: 'AlbumsIndividual',
        component: AlbumsIndividual
      },
      {
        path: 'massive',
        name: 'AlbumsMassive',
        component: AlbumsMassive
      },
      {
        path: ':id',
        name: 'AlbumDetail',
        component: AlbumDetail
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

/**
 * Check if route is different of 'Login' or 'Register'
 * and not have token value in localStorage and redirect
 * to 'Login' route.
 */
// router.beforeEach((to, from, next) => {
//   const isAuthenticated = localStorage.getItem('token')
//   if (to.name !== 'Login' && to.name !== 'Login'&& !isAuthenticated) next({ name: 'Login' })
//   else next()
// })

export default router
